import { lazy } from "react";

/**
 * Pages "service", pages départementales SEO et pages légales/contact.
 * Toutes rendues dans le layout complet (header + footer).
 */

// Pages service
const Particulier = lazy(() => import("@/pages/Particulier"));
const TarifsDemenagementParis = lazy(() => import("@/pages/TarifsDemenagementParis"));
const Entreprise = lazy(() => import("@/pages/Entreprise"));
const GardeMeuble = lazy(() => import("@/pages/GardeMeuble"));
const MonteMeuble = lazy(() => import("@/pages/MonteMeuble"));
const FormulesPage = lazy(() => import("@/pages/Formules"));
const CalculateurVolume = lazy(() => import("@/pages/CalculateurVolume"));
const International = lazy(() => import("@/pages/International"));
const MutationProfessionnelle = lazy(() => import("@/pages/MutationProfessionnelle"));
const DebarrasVideMaison = lazy(() => import("@/pages/DebarrasVideMaison"));
const MontageDemontage = lazy(() => import("@/pages/MontageDemontage"));
const DemenagementMilitaire = lazy(() => import("@/pages/DemenagementMilitaire"));

// Pages départementales SEO (lourdes)
const DemenagementParis75 = lazy(() => import("@/pages/DemenagementParis75"));
const DemenagementSeineEtMarne77 = lazy(() => import("@/pages/DemenagementSeineEtMarne77"));
const DemenagementYvelines78 = lazy(() => import("@/pages/DemenagementYvelines78"));
const DemenagementEssonne91 = lazy(() => import("@/pages/DemenagementEssonne91"));
const DemenagementHautsDeSeine92 = lazy(() => import("@/pages/DemenagementHautsDeSeine92"));
const DemenagementSeineSaintDenis93 = lazy(() => import("@/pages/DemenagementSeineSaintDenis93"));
const DemenagementValDeMarne94 = lazy(() => import("@/pages/DemenagementValDeMarne94"));
const DemenagementValdOise95 = lazy(() => import("@/pages/DemenagementValdOise95"));

// Légal / contact
const MentionsLegales = lazy(() => import("@/pages/MentionsLegales"));
const PolitiqueConfidentialite = lazy(() => import("@/pages/PolitiqueConfidentialite"));
const FAQ = lazy(() => import("@/pages/FAQ"));
const Presentation = lazy(() => import("@/pages/Presentation"));
const Contact = lazy(() => import("@/pages/Contact"));
const ConditionsGenerales = lazy(() => import("@/pages/ConditionsGenerales"));
const UtilisationCookies = lazy(() => import("@/pages/UtilisationCookies"));

export const SERVICE_ROUTES = [
  { path: "/demenagement-particulier", Component: Particulier },
  { path: "/entreprise", Component: Entreprise },
  { path: "/garde-meuble", Component: GardeMeuble },
  { path: "/monte-meuble", Component: MonteMeuble },
  { path: "/formules", Component: FormulesPage },
  { path: "/calculer-mon-volume", Component: CalculateurVolume },
  { path: "/international", Component: International },
  { path: "/mutation-professionnelle", Component: MutationProfessionnelle },
  { path: "/debarras-vide-maison", Component: DebarrasVideMaison },
  { path: "/montage-demontage-meubles", Component: MontageDemontage },
  { path: "/demenagement-militaire", Component: DemenagementMilitaire },
];

export const DEPARTMENT_ROUTES = [
  { path: "/demenagement-paris-75", Component: DemenagementParis75 },
  { path: "/demenagement-seine-et-marne-77", Component: DemenagementSeineEtMarne77 },
  { path: "/demenagement-yvelines-78", Component: DemenagementYvelines78 },
  { path: "/demenagement-essonne-91", Component: DemenagementEssonne91 },
  { path: "/demenagement-hauts-de-seine-92", Component: DemenagementHautsDeSeine92 },
  { path: "/demenagement-seine-saint-denis-93", Component: DemenagementSeineSaintDenis93 },
  { path: "/demenagement-val-de-marne-94", Component: DemenagementValDeMarne94 },
  { path: "/demenagement-val-d-oise-95", Component: DemenagementValdOise95 },
];

export const LEGAL_ROUTES = [
  { path: "/mentions-legales", Component: MentionsLegales },
  { path: "/tarifs-demenagement-paris", Component: TarifsDemenagementParis },
  { path: "/politique-de-confidentialite", Component: PolitiqueConfidentialite },
  { path: "/faq", Component: FAQ },
  { path: "/presentation", Component: Presentation },
  { path: "/contact", Component: Contact },
  { path: "/conditions-generales-dutilisation", Component: ConditionsGenerales },
  { path: "/utilisation-des-cookies", Component: UtilisationCookies },
];
